<template>
    <div style="margin-top:70px;" class="send-planning-page">
    <Filters />
    <TabNavigation />
    <b-row
      v-if="this.$store.getters.filterSuprazone != null && this.$store.getters.filterGroup != 0"
      class="mt-3"
    >
      <bus-planning-card />
    </b-row>
    <b-row v-else>
      <b-col cols="12" class="mt-5">
        <div class="alert alert-danger text-center w-25">
          <i class="fa fa-fw fa-2x fa-exclamation-triangle"></i>
          <span class="text-center m-5 font-weight-bold" style="font-size: 1.2rem !important;">Por favor, seleccione datos para todos los desplegables de la parte superior de la pantalla</span>
        </div>
      </b-col>
      
    </b-row>
  </div>
</template>

<script>
import Filters from "../../components/Filters/Filters";
import TabNavigation from "../../components/Common/TabNavigation";
import BusPlanningCard from "../../components/Excursions/BusPlanning/BusPlanningCard"

export default {
    components: {
        Filters,
        TabNavigation,
        BusPlanningCard,
    }
}
</script>